import React, { Component } from 'react'
import autoBind from 'react-autobind'
import PropTypes from 'prop-types'
import { Transition } from 'react-transition-group'
import { fadeIn as enterDefault, fadeOut as exitDefault } from './Animations'
import _ from 'lodash'
class Anime extends Component {
  constructor(props) {
    super(props)
    this.state = {
      done: false,
      childCount: 0,
      progress: 0,
    }
    this.ani = null
    this.lock = false
    autoBind(this)
  }

  componentWillUnmount() {
    if (this.ani) this.ani.update = null
  }

  componentDidMount() {
    if (!this.props.appear) {
      this.setState({ done: true })
    }
  }

  start(animation, el, cb) {
    this.pause()
    this.ani = animation(el)
    this.setState({ done: false, progress: 0 }, () => {
      cb(this.lock)
    })
  }

  updateProgress({ progress }) {
    this.setState({ progress })
  }

  pause() {
    if (this.ani) this.ani.pause()
  }

  enter(el) {
    const { enter, onEnter } = this.props
    this.start(enter, el, locked => {
      onEnter(locked)
      this.lock = true
    })
  }

  exit(el) {
    const { exit, onExit } = this.props
    if (exit) this.start(exit, el, onExit)
  }

  entered() {
    const { onEntered } = this.props

    this.setState({ done: true }, () => {
      onEntered && onEntered()
    })
  }

  exited() {
    const { onExited } = this.props
    this.lock = false
    this.setState({ done: false }, () => {
      onExited && onExited()
    })
  }

  addEndListener(node, done) {
    this.ani.finished.then(done)
  }

  childEntering(locked) {
    if (!locked)
      this.setState(({ childCount }) => ({ childCount: childCount + 1 }))
  }

  childExited(locked) {
    this.setState(({ childCount }) => ({ childCount: childCount - 1 }))
  }

  add(child) {
    const clone = c =>
      React.cloneElement(c, {
        onEnter: status => {
          c.props.onEnter && c.props.onEnter()
          this.childEntering(status)
        },
        onExited: status => {
          c.props.onExited && c.props.onExited()
          this.childExited(status)
        },
      })

    return _.isArray(child) ? child.map(clone) : clone(child)
  }

  renderChildren(state) {
    const {
      children,
      containerStyle: style,
      containerClass,
      className,
      protectChildren,
      renderContainer,
      container,
    } = this.props

    const { done } = this.state
    const c = _.isFunction(children)
      ? children({
          state,
          done,
          add: this.add,
          count: this.state.childCount,
        })
      : protectChildren
      ? children.map((c, i) => <div key={`protected-child-${i}`}>{c}</div>)
      : children

    if (renderContainer) {
      return renderContainer({ children: c })
    }

    if (container) {
      return React.createElement(container, null, c)
    }

    return (
      <div
        {..._.pickBy({ className: [containerClass, className].join(' ') })}
        {..._.pickBy({ style })}
      >
        {c}
      </div>
    )
  }

  render() {
    const { unmountOnExit, appear } = this.props
    const released = this.state.childCount === 0

    return (
      <Transition
        in={this.props.in || !released}
        appear={appear}
        onEnter={this.enter}
        onExit={this.exit}
        onEntered={this.entered}
        onExited={this.exited}
        addEndListener={this.addEndListener}
        unmountOnExit={unmountOnExit}
      >
        {this.renderChildren()}
      </Transition>
    )
  }
}

Anime.defaultProps = {
  in: true,
  enter: enterDefault(),
  exit: exitDefault(),
  unmountOnExit: true,
  appear: true,
  onEnter: x => x,
  onExit: x => x,
}

Anime.propTypes = {
  enter: PropTypes.func,
  exit: PropTypes.func,
  in: PropTypes.bool,
  containerStyle: PropTypes.object,
  containerClass: PropTypes.string,
  container: PropTypes.object,
  className: PropTypes.string,
  onEntered: PropTypes.func,
  onExited: PropTypes.func,
  onEnter: PropTypes.func,
  onExit: PropTypes.func,
  unmountOnExit: PropTypes.bool,
  appear: PropTypes.bool,
  protectChildren: PropTypes.bool,
}

export default Anime
